import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
export default new Router({
    // mode: 'history',
    cache: false,
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/404',
            name: 'NotFound',
            meta: {
                title: '404'
            },
            component: () => import('./views/404/index.vue')
        },
        {
            path: '/login',
            name: '/login',
            meta: {
                title: '登录'
            },
            component: () => import('./views/login/login.vue')
        },
        {
            path: '/mblogin',
            name: '/mblogin',
            meta: {
                title: '登录'
            },
            component: () => import('./views/member/login.vue')
        },
        {
            path: '/',
            redirect: '/404',
            meta: {
                title: '404'
            },
            // component: () => import('./views/empower/appointment.vue')
        },
        {
            path: '/home',
            name: '/home',
            meta: {
                title: '首页'
            },
            component: () => import('./views/home/home.vue')
        },
        {
            path: '/appointment',
            name: '/appointment',
            meta: {
                title: '预约管理'
            },
            component: () => import('./views/appointment/index.vue')
        },
        {
            path: '/msg',
            name: '/msg',
            meta: {
                title: '消息提醒'
            },
            component: () => import('./views/msg/index.vue')
        },
        {
            path: '/kdgl',
            name: '/msg',
            meta: {
                title: '快递管理'
            },
            component: () => import('./views/msg/kdgl/list.vue')
        },
        {
            path: '/jdgl',
            name: '/msg',
            meta: {
                title: '金豆管理'
            },
            component: () => import('./views/msg/jdgl/list.vue')
        },
        {
            path: '/my',
            name: '/my',
            meta: {
                title: '我的'
            },
            component: () => import('./views/my/index.vue')
        },
        {
            path: '/empChoose',
            name: '/empChoose',
            meta: {
                title: '员工选择房间'
            },
            component: () => import('./views/empBilling/choose.vue')
        },
        {
            path: '/empBilling',
            name: '/empBilling',
            meta: {
                title: '员工开单选项'
            },
            component: () => import('./views/empBilling/index.vue')
        },
        {
            path: '/empLqBilling',
            name: '/empLqBilling',
            meta: {
                title: '员工领取开单选项'
            },
            component: () => import('./views/empBilling/lqkd.vue')
        },
        {
            path: '/empTake/:orderId',
            name: '/empTake',
            meta: {
                title: '员工取单选项'
            },
            component: () => import('./views/empBilling/take.vue')
        },
        {
            path: '/mdChoose',
            name: '/mdChoose',
            meta: {
                title: '门店选择房间'
            },
            component: () => import('./views/mdBilling/choose.vue')
        },
        {
            path: '/mdBilling',
            name: '/mdBilling',
            meta: {
                title: '门店开单选项'
            },
            component: () => import('./views/mdBilling/index.vue')
        },
        {
            path: '/mdTake/:orderId',
            name: '/mdTake',
            meta: {
                title: '门店取单选项'
            },
            component: () => import('./views/mdBilling/take.vue')
        },
        {
            path: '/addBillingTask',
            name: '/addBillingTask',
            meta: {
                title: '创建排号'
            },
            component: () => import('./views/numlist/index.vue')
        },
        {
            path: '/wfp',
            name: '/wfp',
            meta: {
                title: '未分配领取'
            },
            component: () => import('./views/wfp/index.vue')
        },
        {
            path: '/customer',
            name: '/customer',
            meta: {
                title: '客户中心'
            },
            component: () => import('./views/customer/index.vue')
        },
        {
            path: '/service',
            name: '/service',
            meta: {
                title: '客户服务'
            },
            component: () => import('./views/customer/service.vue')
        },
        {
            path: '/addEmp',
            name: '/addEmp',
            meta: {
                title: '新增员工'
            },
            component: () => import('./views/emp/index.vue')
        },
        {
            path: '/turnover',
            name: '/turnover',
            meta: {
                title: '流水对单'
            },
            component: () => import('./views/turnover/index.vue')
        },
        {
            path: '/empTurnover',
            name: '/empTurnover',
            meta: {
                title: '员工流水对单'
            },
            component: () => import('./views/turnover/emp.vue')
        },
        {
            path: '/msanalysis',
            name: '/msanalysis',
            meta: {
                title: '秒杀分析'
            },
            component: () => import('./views/analysis/ms/index.vue')
        },
        {
            path: '/operate',
            name: '/operate',
            meta: {
                title: '秒杀分析'
            },
            component: () => import('./views/analysis/operate/index.vue')
        },
        {
            path: '/tgAnalysis',
            name: '/tgAnalysis',
            meta: {
                title: '推广分析'
            },
            component: () => import('./views/analysis/tgAnalysis/index.vue')
        },
        {
            path: '/orderAnalysis',
            name: '/orderAnalysis',
            meta: {
                title: '订单分析'
            },
            component: () => import('./views/analysis/orderAnalysis/index.vue')
        },
        {
            path: '/tcs',
            name: '/tcs',
            meta: {
                title: '套餐/次卡'
            },
            component: () => import('./views/package/index.vue')
        },
        {
            path: '/fwMdCmp',
            name: '/fwMdCmp',
            meta: {
                title: '顾客的消费'
            },
            component: () => import('./views/customer/center/myMdCmp.vue')
        },
        {
            path: '/fwMdTc',
            name: '/fwMdTc',
            meta: {
                title: '顾客的套餐'
            },
            component: () => import('./views/customer/center/myMdTc.vue')
        },
        {
            path: '/account',
            name: '/account',
            meta: {
                title: '账户设置'
            },
            component: () => import('./views/my/account.vue')
        },
        {
            path: '/address',
            name: '/address',
            meta: {
                title: '地址管理'
            },
            component: () => import('./views/my/address.vue')
        },
        {
            path: '/addAds',
            name: '/addAds',
            meta: {
                title: '新增地址'
            },
            component: () => import('./views/my/addAds.vue')
        },
        {
            path: '/editAds',
            name: '/editAds',
            meta: {
                title: '编辑地址'
            },
            component: () => import('./views/my/editAds.vue')
        },
        {
            path: '/userBdMsg',
            name: '/userBdMsg',
            meta: {
                title: '消息通知授权'
            },
            component: () => import('./views/my/bdmsg.vue')
        },
        {
            path: '/userBdPay',
            name: '/userBdPay',
            meta: {
                title: '商品支付授权'
            },
            component: () => import('./views/my/bdpay.vue')
        },
        {
            path: '/members',
            name: '/members',
            meta: {
                title: '会员扫码绑定'
            },
            component: () => import('./views/member/index.vue')
        },
        {
            path: '/mys',
            name: '/mys',
            meta: {
                title: '会员中心'
            },
            component: () => import('./views/member/mys.vue')
        },
        {
            path: '/mbinfo',
            name: '/mbinfo',
            meta: {
                title: '授权页面'
            },
            component: () => import('./views/member/mbinfo.vue')
        },
        {
            path: '/myCards',
            name: '/myCards',
            meta: {
                title: '我的会员卡'
            },
            component: () => import('./views/member/myCards.vue')
        },
        {
            path: '/myMdCmp',
            name: '/myMdCmp',
            meta: {
                title: '我的消费'
            },
            component: () => import('./views/member/myMdCmp.vue')
        },
        {
            path: '/myMdTc',
            name: '/myMdTc',
            meta: {
                title: '我的套餐'
            },
            component: () => import('./views/member/myMdTc.vue')
        },
        {
            path: '/editMb',
            name: '/editMb',
            meta: {
                title: '编辑用户信息'
            },
            component: () => import('./views/member/mbedit.vue')
        },
        {
            path: '/success',
            name: '/success',
            meta: {
                title: '支付结果'
            },
            component: () => import('./views/success/index.vue')
        },
        {
            path: '/renew',
            name: '/renew',
            meta: {
                title: '门店续费'
            },
            component: () => import('./views/renew/index.vue')
        },
        {
            path: '/svd',
            name: '/svd',
            meta: {
                title: '门店续费'
            },
            component: () => import('./views/renew/svd.vue')
        },
        {
            path: '/fbs',
            name: '/fbs',
            meta: {
                title: 'fbs'
            },
            component: () => import('./views/fbs/fbs.vue')
        },
        {
            path: '/itinfo',
            name: '/itinfo',
            meta: {
                title: '图文详情页面'
            },
            component: () => import('./views/fbs/itinfo.vue')
        },
        {
            path: '/fxfbs',
            name: '/fxfbs',
            meta: {
                title: '分享预约开通页面'
            },
            component: () => import('./views/fbs/fxfbs.vue')
        },
        {
            path: '/yykt',
            name: '/yykt',
            meta: {
                title: '分享预约开通页面'
            },
            component: () => import('./views/fbs/yykt.vue')
        },
        {
            path: '/spuDetails',
            name: '/spuDetails',
            meta: {
                title: '商品详情页'
            },
            component: () => import('./views/fbs/details.vue')
        },
        {
            path: '/buy',
            name: '/buy',
            meta: {
                title: '商品详情页'
            },
            component: () => import('./views/fbs/buy.vue')
        },
        {
            path: '/myorder',
            name: '/myorder',
            meta: {
                title: '我的订单'
            },
            component: () => import('./views/order/myOrder.vue')
        },
        {
            path: '/orderDetails',
            name: '/orderDetails',
            meta: {
                title: '订单详情'
            },
            component: () => import('./views/order/details.vue')
        },
    ]
})